export function convertToC(value) {
  const fTempVal = parseFloat(value);
  const cTempVal = (fTempVal - 32) * (5 / 9);
  return Math.round(cTempVal);
}

export function convertToF(value) {
  const cTempVal = parseFloat(value);
  const fTempVal = cTempVal * (9 / 5) + 32;
  return Math.round(fTempVal);
}
